export function formatDate(formatters, spec) {
    var _a;
    if (!spec || typeof spec.value === 'undefined') {
        console.warn('formatDate requires "value" property defined');
        return null;
    }
    var value = spec.value, _b = spec.format, format = _b === void 0 ? 'L' : _b;
    if (!value) {
        return value;
    }
    var _c = formatters.preferences, locale = _c.locale, dateFormat = _c.dateFormat, timeFormat = _c.timeFormat, localeMode = _c.localeMode;
    var instance = formatters.getDateTimeFormatter(locale, dateFormat, timeFormat);
    var dateTime = instance(value);
    var newFormat = (_a = formatters.preferences.dateFormat[format]) !== null && _a !== void 0 ? _a : format;
    var formatted = dateTime.format(newFormat);
    if (!localeMode) {
        return formatted;
    }
    switch (localeMode) {
        case 'empty':
            return '';
        case 'upper':
            return formatted.toUpperCase();
        case 'asian':
            return "".concat(formatted, "\u610F");
        case 'dev':
            return "".concat(formatted, "'");
        default:
            return formatted;
    }
}
